import { isMenuNode } from './isMenuNode';

/**
 * Menu tree from the menu nodes of `myAccess` (catalog order, parents before children) and the
 * route mapping. Blocks and groups inside views are skipped silently. A menu node without
 * mapping is left out and warned; a group without children too.
 */
export function buildNavigationItems(accessNodes, routes, translate) {
  const buildItemsUnder = (parentId) =>
    accessNodes
      .filter((node) => node.parent === parentId && isMenuNode(node))
      .flatMap((node) => {
        const route = routes[node.id];
        if (!route) {
          console.warn('Navigation: no route mapping for catalog node', node.id);
          return [];
        }

        const children = buildItemsUnder(node.id);
        const isEmptyGroup = route.group === true && children.length === 0;
        if (isEmptyGroup) {
          return [];
        }

        return [
          {
            id: node.id,
            label: translate(node.labelKey),
            link: route.group === true ? null : route.link,
            children,
          },
        ];
      });

  return buildItemsUnder(null);
}
